import { register } from "@shopify/theme-sections";

register("two-four-up-content", {
  initContentVideo() {
    let bntPlay = document.querySelectorAll(
      ".two-four-content__item .btn-play"
    );
    if (bntPlay.length) {
      bntPlay.forEach((button, index) => {
        button.innerHTML = `<svg width="30" height="29" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="14.6666" cy="14.5" r="13.5" fill="white" stroke="black" stroke-width="2"/>
        <path d="M21.0416 14.5L12.2916 8.25L12.2916 20.75L21.0416 14.5Z" fill="black"/>
        </svg>`;

        let src = document
          .getElementById("data-" + button.dataset.idVideo)
          .getAttribute("src");

        async function getData() {
          let response = await fetch(src);
          if (response.ok) {
            let data = await response.json();
            const id_img = "vimeo-" + data[0].id;
            const id_container = "vimeo-container-" + data[0].id;

            document.getElementById(id_container).style.backgroundImage =
              "url(" + data[0].thumbnail_large + ")";
            document
              .getElementById(id_img)
              .setAttribute("src", data[0].thumbnail_large);
          } else {
            console.log("error", response.status);
          }
        }

        getData();

        let target = button.dataset.btnId;
        let container = this.container.querySelector(
          `.embed-container-${target}`
        );
        let iframe = this.container.querySelector(`.iframe-${target}`);
        button.addEventListener("click", function (e) {
          button.style.display = "none";
          this.parentNode.querySelector("img").style.display = "none";
          container.classList.add("visible");
          let iframeVimeo = new Vimeo.Player(iframe);
          iframeVimeo.play();
          container.parentNode.classList.add("embed-init");
        });
      });
    }
  },

  onLoad: function (e) {
    this.initContentVideo();
  },
});
